/* eslint-disable */

export const Currency = {
  DOLLAR: 'USD'
};
